/**
 * Zzzing Guest API
 * Zzzing Guest API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { AirportTransfer } from '../model/models';
import { AirportTransferBookingDetails } from '../model/models';
import { AirportTransferBookingParams } from '../model/models';
import { AirportTransferPrice } from '../model/models';
import { AirportTransferPriceListFilter } from '../model/models';
import { Coordinates } from '../model/models';
import { VehicleType } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class AirportTransfersService {

    protected basePath = 'https://dev.zzzing.com/api/guest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Book an airport transfer
     * @param airportTransferId Airport Transfer Id
     * @param airportTransferBookingParams Airport transfer booking details
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public bookAirportTransfer(airportTransferId: string, airportTransferBookingParams: AirportTransferBookingParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<AirportTransferBookingDetails>;
    public bookAirportTransfer(airportTransferId: string, airportTransferBookingParams: AirportTransferBookingParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<AirportTransferBookingDetails>>;
    public bookAirportTransfer(airportTransferId: string, airportTransferBookingParams: AirportTransferBookingParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<AirportTransferBookingDetails>>;
    public bookAirportTransfer(airportTransferId: string, airportTransferBookingParams: AirportTransferBookingParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (airportTransferId === null || airportTransferId === undefined) {
            throw new Error('Required parameter airportTransferId was null or undefined when calling bookAirportTransfer.');
        }
        if (airportTransferBookingParams === null || airportTransferBookingParams === undefined) {
            throw new Error('Required parameter airportTransferBookingParams was null or undefined when calling bookAirportTransfer.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<AirportTransferBookingDetails>(`${this.configuration.basePath}/services/airport_transfers/${encodeURIComponent(String(airportTransferId))}`,
            airportTransferBookingParams,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the price for a particular airport transfer request
     * @param airportTransferId Airport transfer Id
     * @param numberOfPassengers 
     * @param date 
     * @param pickupTime 
     * @param propertyAddress 
     * @param propertyCoordinates 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAirportTransferPrice(airportTransferId: string, numberOfPassengers: number, date: string, pickupTime?: string, propertyAddress?: string, propertyCoordinates?: Coordinates, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<AirportTransferPrice>;
    public getAirportTransferPrice(airportTransferId: string, numberOfPassengers: number, date: string, pickupTime?: string, propertyAddress?: string, propertyCoordinates?: Coordinates, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<AirportTransferPrice>>;
    public getAirportTransferPrice(airportTransferId: string, numberOfPassengers: number, date: string, pickupTime?: string, propertyAddress?: string, propertyCoordinates?: Coordinates, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<AirportTransferPrice>>;
    public getAirportTransferPrice(airportTransferId: string, numberOfPassengers: number, date: string, pickupTime?: string, propertyAddress?: string, propertyCoordinates?: Coordinates, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (airportTransferId === null || airportTransferId === undefined) {
            throw new Error('Required parameter airportTransferId was null or undefined when calling getAirportTransferPrice.');
        }
        if (numberOfPassengers === null || numberOfPassengers === undefined) {
            throw new Error('Required parameter numberOfPassengers was null or undefined when calling getAirportTransferPrice.');
        }
        if (date === null || date === undefined) {
            throw new Error('Required parameter date was null or undefined when calling getAirportTransferPrice.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (numberOfPassengers !== undefined && numberOfPassengers !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>numberOfPassengers, 'number_of_passengers');
        }
        if (date !== undefined && date !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>date, 'date');
        }
        if (pickupTime !== undefined && pickupTime !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>pickupTime, 'pickup_time');
        }
        if (propertyAddress !== undefined && propertyAddress !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>propertyAddress, 'property_address');
        }
        if (propertyCoordinates !== undefined && propertyCoordinates !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>propertyCoordinates, 'property_coordinates');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<AirportTransferPrice>(`${this.configuration.basePath}/services/airport_transfers/${encodeURIComponent(String(airportTransferId))}/price`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the price list for a particular airport transfer request
     * @param airportTransferId Airport Transfer Id
     * @param priceListFilter 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAirportTransferPriceList(airportTransferId: string, priceListFilter?: AirportTransferPriceListFilter, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<AirportTransferPrice>>;
    public getAirportTransferPriceList(airportTransferId: string, priceListFilter?: AirportTransferPriceListFilter, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<AirportTransferPrice>>>;
    public getAirportTransferPriceList(airportTransferId: string, priceListFilter?: AirportTransferPriceListFilter, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<AirportTransferPrice>>>;
    public getAirportTransferPriceList(airportTransferId: string, priceListFilter?: AirportTransferPriceListFilter, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (airportTransferId === null || airportTransferId === undefined) {
            throw new Error('Required parameter airportTransferId was null or undefined when calling getAirportTransferPriceList.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (priceListFilter !== undefined && priceListFilter !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>priceListFilter, 'price_list_filter');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<AirportTransferPrice>>(`${this.configuration.basePath}/services/airport_transfers/${encodeURIComponent(String(airportTransferId))}/price_list`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the available airport transfer vehicle types
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAirportTransferVehicleTypes(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<VehicleType>>;
    public getAirportTransferVehicleTypes(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<VehicleType>>>;
    public getAirportTransferVehicleTypes(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<VehicleType>>>;
    public getAirportTransferVehicleTypes(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<VehicleType>>(`${this.configuration.basePath}/services/airport_transfers/vehicle_types`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a list of airport transfers
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAirportTransfers(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<AirportTransfer>>;
    public getAirportTransfers(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<AirportTransfer>>>;
    public getAirportTransfers(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<AirportTransfer>>>;
    public getAirportTransfers(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<AirportTransfer>>(`${this.configuration.basePath}/services/airport_transfers`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
